//Library
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";

//Material
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
//Component
//Function
import { SetTokens } from "../../utils/sessions";
import { isEmptyStr } from "../../utils/common-function";
//Store
import { GetTokenByPassword } from "./api";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(-1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const SignIn = () => {
  const classes = useStyles();
  const Methods = useForm({ mode: "onChange" });
  const history = useHistory();
  const { getValues, setError, clearErrors, errors } = Methods;
  const [HideError,setHideError] = useState(true);
  //useEffect(() => {
  //    if (CheckToken()) {
  //        history.push('/')
  //    }
  //}, [])
  const Login = async () => {
    let data = Methods.getValues();

    if (isEmptyStr(data.username.trim())) {
      setError("username", {
        type: "manual",
        message: `Please input username`,
      });
      return;
    }
    if (isEmptyStr(data.password.trim())) {
      setError("password", {
        type: "manual",
        message: `Please input password`,
      });
      return;
    }
    //var path = window.location.protocol + '//' + window.location.host
    let jwt = await GetTokenByPassword({
      UserId: data.username,
      Password: data.password,
      Aud: "sGSJp4eU0APoUwH0w09p",
    });
    if(!jwt){
      setHideError(false);
      return;
    }
    if (jwt?.Incorrect) {
      setHideError(false);
      return;
    }

    if (jwt) {
      setHideError(true);
      SetTokens(jwt.UserId, jwt.AccessToken, jwt.RefreshToken);
      //            GetMenuList()
      history.push("/");
    }
    else{
      setHideError(false);
    }
  };
  const ClearError = async (e) => {
    clearErrors(e.target.name);
  };
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: "80vh" }}
    >
      <Grid item xs={12}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5" paragraph>
              Welcome to BI Web Portal
            </Typography>

            <form className={classes.form}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                onChange={ClearError}
                inputRef={Methods.register}
                autoFocus
                error={errors?.hasOwnProperty("username")}
                helperText={errors?.["username"]?.message || ''}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                inputRef={Methods.register}
                onChange={ClearError}
                error={errors?.hasOwnProperty("password")}
                helperText={errors?.["password"]?.message || ''}
              />
              <Typography color="error" hidden={HideError}>Invalid username or password.</Typography>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={Methods.handleSubmit(Login)}
              >
                Sign In
              </Button>
            </form>
          </div>
          <Box mt={8}>
            <Copyright />
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};
export default SignIn;
